module.exports = __webpack_public_path__ + "img/img_xiakuan@2x.11ecc593.png";